import { createReducer, on } from "@ngrx/store";
import { ClearFormAdminstratorState, CreateAdmin, CreateAdminError, CreateAdminSuccess } from "./form-administrator.actions";
import { FormAdministratorState, initialFormAdministratorState } from "./form-administrator.state";

export const FormAdministratorReducers = createReducer(
    initialFormAdministratorState, 
    on(CreateAdmin, (state): FormAdministratorState => {
        return {
            ...state,
            loading: true,
            admin: null
        }
    }),
    on(CreateAdminSuccess, (state, action): FormAdministratorState => {
        return {
            ...state,
            loading: false,
            admin: action.createdAdmin
        }
    }),
    on(CreateAdminError, (state, action): FormAdministratorState => {
        return {
            ...state, 
            loading: false,
            error: action.error
        }
    }),
    on(ClearFormAdminstratorState, (state): FormAdministratorState => {
        return {
            ...state,
            loading: false,
            admin: null,
            error: null
        }
    })
);